import React from 'react';
import { LOGO_URL } from '../mock';
import { Search, User, ShoppingBag, Sun, Moon, Menu, X } from 'lucide-react';

export default function Header({ theme, onToggleTheme, onOpenCart, cartCount = 0, onShopClick }) {
  const [open, setOpen] = React.useState(false);
  const dark = theme === 'dark';

  return (
    <header className={`sticky top-0 z-40 border-b ${dark ? 'bg-neutral-950/85 border-white/5' : 'bg-white/85 border-black/5'} backdrop-blur-md`}>
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center gap-8">
            <a href="/" className="flex items-center gap-2">
              <img src={LOGO_URL} alt="Corevive" className="h-9 w-9 rounded-full object-cover" style={{ filter: dark ? 'invert(1)' : 'none' }} />
              <span className="font-grotesk font-bold tracking-[0.22em] text-[13px]">COREVIVE</span>
            </a>
            <nav className="hidden md:flex items-center gap-7 text-[13px] uppercase tracking-[0.12em] font-medium">
              <a href="#product" className="hover:text-teal transition-colors">Product</a>
              <a href="#benefits" className="hover:text-teal transition-colors">Benefits</a>
              <a href="#science" className="hover:text-teal transition-colors">Science</a>
              <a href="#faq" className="hover:text-teal transition-colors">FAQ</a>
            </nav>
          </div>

          <div className="flex items-center gap-5 text-[12px] uppercase tracking-[0.14em]">
            <button onClick={onShopClick} className="hidden sm:inline-flex px-3.5 py-1.5 rounded-full bg-[color:var(--cv-teal)] text-white text-[11px] font-semibold tracking-[0.14em] hover:bg-[color:var(--cv-teal-dark)] transition">
              Shop TriMag
            </button>
            <button onClick={onToggleTheme} aria-label="Toggle theme" className="hidden sm:inline-flex items-center justify-center h-8 w-8 rounded-full border border-current/10 hover:opacity-70 transition">
              {dark ? <Sun size={14} /> : <Moon size={14} />}
            </button>
            <button onClick={onOpenCart} className="flex items-center gap-1.5 hover:opacity-70 transition">
              <ShoppingBag size={14} /> <span>Cart {cartCount}</span>
            </button>
            <button onClick={() => setOpen(!open)} className="md:hidden" aria-label="Menu">
              {open ? <X size={18} /> : <Menu size={18} />}
            </button>
          </div>
        </div>
        {open && (
          <div className="md:hidden pb-4 flex flex-col gap-3 text-[13px] uppercase tracking-[0.12em]">
            <a href="#product" onClick={() => setOpen(false)}>Product</a>
            <a href="#benefits" onClick={() => setOpen(false)}>Benefits</a>
            <a href="#science" onClick={() => setOpen(false)}>Science</a>
            <a href="#faq" onClick={() => setOpen(false)}>FAQ</a>
          </div>
        )}
      </div>
    </header>
  );
}
